import type { CreateInvitationPayload, InitialInvitationValues, InviteesRef } from '../Invitations.types';

export function composeInvitations(
  inviteesFormRef: InviteesRef,
  invitationDetails: InitialInvitationValues['invitationDetails'],
): Array<CreateInvitationPayload> {
  const composedInvitations: Array<CreateInvitationPayload> = [];

  const inviteeForms = inviteesFormRef.current ? Object.values(inviteesFormRef.current.getForms()) : [];

  inviteeForms.forEach((invitee) => {
    if (invitee.validate()) {
      const composedInvite: CreateInvitationPayload = {
        firstName: invitee.values.firstName,
        lastName: invitee.values.lastName,
        email: invitee.values.email,
        mobile: invitee.values.mobile,
        expiry: invitationDetails.expiry,
        company: invitationDetails.company,
        subject: invitationDetails.subject,
        visitorNotes: invitationDetails.visitorNotes,
        adminNotes: invitationDetails.adminNotes,
        visitorType: invitationDetails.visitorTypeOption.value,
        startDate: invitationDetails.validFrom,
        endDate: invitationDetails.validTo,
        siteId: invitationDetails.siteOption.value,
        hostId: invitationDetails.hostOption?.value,
        zoneId: invitationDetails.zone?.value,
      };

      composedInvitations.push(composedInvite);
    }
  });

  return composedInvitations;
}
